import React from 'react';
import { FadeIn } from './FadeIn';
export function Qualifier() {
  return <section className="py-16 sm:py-24 px-4 bg-padel-surface border-y border-padel-muted" data-id="element-213">
      <div className="max-w-3xl mx-auto text-center" data-id="element-214">
        <FadeIn data-id="element-215">
          <h2 className="text-2xl sm:text-3xl font-display font-bold text-white mb-8" data-id="element-216">
            Pero antes de decirte el precio, necesito ser honesto con vos.
          </h2>

          <div className="space-y-6 text-lg text-gray-300 leading-relaxed" data-id="element-217">
            <p data-id="element-218">
              Este pack <strong className="text-red-400" data-id="element-219">no es</strong> para el
              profe que quiere más contenido para guardar en una carpeta.
            </p>
            <p data-id="element-220">
              Es para el profe que está dispuesto a usarlo. Que va a abrir el
              Tomo 1 esta semana y va a planificar el trimestre. Que va a
              imprimir los Tickets de Mejora y los va a entregar al terminar la
              próxima clase. Que va a hacer el ritual de los 20 minutos el
              próximo domingo en lugar de pasar horas buscando en YouTube.
            </p>
            <p className="text-white font-bold text-xl mt-8" data-id="element-221">
              Si eso sos vos, este pack va a cambiar la forma en que trabajás.{' '}
              <br className="hidden sm:block" data-id="element-222" />
              <span className="text-padel-lime" data-id="element-223">
                No en tres meses. En la primera semana.
              </span>
            </p>
            <p className="text-sm text-gray-500 mt-8 uppercase tracking-widest font-bold" data-id="element-224">
              Si no estás listo para usarlo, no te lo vendas a vos mismo. No es
              para juntar.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}